var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"transparent"}},[_c('router-view',{staticClass:"text-uppercase",attrs:{"id":"app"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }